module.exports = __webpack_public_path__ + "img/icon_5_50.30797258.png";